import { accountAbi as erc7579Abi } from '../../../account/erc7579-implementation/constants/abis'

export const accountAbi = [...erc7579Abi]
